/**
 * Verrou de la rubrique Certification (menu commerçant) : code d'accès fixe demandé une fois par session.
 * Garde d'interface (évite qu'un employé ouvre les écrans fiscaux), pas une barrière de sécurité : les données
 * restent protégées par la RLS. Super admin et impersonation passent sans code.
 */
const CERTIFICATION_CODE = '8888';
const STORAGE_KEY = 'vp_certification_unlocked';

export const checkCertificationCode = (code: string): boolean => code.trim() === CERTIFICATION_CODE;

export const isCertificationUnlocked = (): boolean => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const unlockCertification = (): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch {
    /* stockage indisponible : le déverrouillage vaut pour l'écran courant seulement */
  }
};
